import { getHeaderOptions, getHttpService } from './http-service';
import {
  IUser,
  IAdviserConnect,
} from 'types';
import { standardFormatWithTime, sortDate } from 'helpers';


const httpClient = getHttpService();

const sortAndFormat = (items) =>
  items.sort(sortDate('createdAt')).map((i) => ({
    ...i,
    createdAt: standardFormatWithTime(i.createdAt),
  }));

export interface IConnectAdviserBody {
  eventUrl?: string;
  phoneNumber?: string;
  name: string;
  message: string;
  policies: any;
  underwritingQuestions?: any;
}

export const connectAdviser = (connectAdviserBody: IConnectAdviserBody) => {
  return httpClient.post(`/adviser/connectadviser`, connectAdviserBody, {
    headers: getHeaderOptions(),
  });
};

export const getAllAdviserUserConnects = () => {
  return httpClient
    .get(`/adviser/adviseruserconnect`, {
      headers: getHeaderOptions(),
    })
    .then((res) => {
      res.data = sortAndFormat(res.data);
      return res;
    });
};

export const getAllAdviserUserConnectsForUser = (userId: string) => {
  userId = encodeURIComponent(userId);
  return httpClient.get(`/adviser/adviseruserconnect/user/${userId}`, {
    headers: getHeaderOptions(),
  });
};

export const getAdviserConnectByIdSk = (id: string, sk: string) => {
  const encodedId = encodeURIComponent(id);
  const encodedSk = encodeURIComponent(sk);
  return httpClient.get(
    `/adviser/adviseruserconnect/${encodedId}/${encodedSk}`,
    {
      headers: getHeaderOptions(),
    },
  );
};

export const updateAdviserConnect = (adviserConnect: IAdviserConnect) => {
  return httpClient.put('/adviser/adviseruserconnect', adviserConnect, {
    headers: getHeaderOptions(),
  });
};

export const updateAdviserConnectUser = (
  adviserConnect: Partial<IAdviserConnect>,
) => {
  return httpClient.put('/adviser/adviseruserconnect/user', adviserConnect, {
    headers: getHeaderOptions(),
  });
};

export const createAdviserInquiry = (data) => {
  return httpClient.post(`/adviser/inquiry`, data, {
    headers: getHeaderOptions(),
  });
};
